<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="选择状态" clearable>
          <el-option label="待处理" :value="0"></el-option>
          <el-option label="已处理" :value="1"></el-option>
          <el-option label="失败" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="query.type" placeholder="选择状态" clearable>
          <el-option v-for="(v,i) in modeList" :key="i" :label="v.name" :value="v.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="手机号">
        <el-input
          placeholder="请输入手机号"
          v-model="query.principal_mobile"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>
          {{ getLabel("modeList", row.type) || row.type }}
        </div>
      </template>
      <template #status="{ row }">
        <el-tag size="small" type="info" v-if="row.status === 0">待审核</el-tag>
        <el-tag size="small" type="success" v-if="row.status === 1"
          >已处理</el-tag
        >
        <el-tag size="small" type="danger" v-if="row.status === 2">失败</el-tag>
      </template>
      <template #handle="{ row }">
        <el-button
          size="small"
          v-if="row.status === 0"
          type="success"
          @click="openHandler(row)"
          >处理</el-button
        >
        <el-button size="small" @click="openInfo(row)" type="primary"
          >详情</el-button
        >
      </template>
    </auto-table>

    <el-dialog
      title="处理结果"
      :visible.sync="authShow"
      width="30%"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="80px">
          <el-form-item label="说明">
            <el-input
              type="textarea"
              placeholder=""
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="reamrk"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="updateStatus(2)">处理失败</el-button>
        <el-button type="primary" @click="updateStatus(1)">处理成功</el-button>
      </span>
    </el-dialog>

    <!-- 处理审核意见 -->
    <el-dialog title="处理结果" :visible.sync="show" width="30%">
      <div>
        <el-form label-width="80px">
          <el-form-item label="申请人">
            {{ curAuth.principal_name }}
          </el-form-item>
          <el-form-item label="审核结果">
            <el-tag size="small" type="info" v-if="curAuth.status === 0"
              >待处理</el-tag
            >
            <el-tag size="small" type="success" v-if="curAuth.status === 1"
              >已处理</el-tag
            >
            <el-tag size="small" type="danger" v-if="curAuth.status === 2"
              >拒绝</el-tag
            >
          </el-form-item>
          <el-form-item label="说明">
            {{ curAuth.else_img }}
          </el-form-item>
          <el-form-item label="处理结果">
            {{ curAuth.shop_img }}
          </el-form-item>
           <el-form-item label="备注">
            {{ curAuth.mechanism_name }}
          </el-form-item>

          
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {

  data() {
    return {
      modeList: [
        {
          name: "公会入驻_心悦",
          value: "guild_x",
        },
         {
          name: "门店合作_心悦",
          value: "venue_x",
        },
        {
          name: "运营方面_心悦",
          value: "ope_x",
        },
        {
          name: "代理商_心悦",
          value: "agent_x",
        },
        {
          name: "其他_心悦",
          value: "other_x",
        },
        {
          name: "德商汇电商",
          value: "eCommerce",
        },
        
      ],
      imgShow: false,
      DataList: [],
      coach_id: "",
      query: {
        status: 0,
        real_name: "",
        createTime: [],
        type: null,
      },
      Option: [
        { name: "联系人", value: "principal_name" },
        { name: "电话", value: "principal_mobile" },
        { name: "合作说明", value: "else_img" },
        { name: "状态", value: "status", type: "custom" },
        { name: "类型", value: "type",type: "custom"  },
        { name: "提交时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom", width: "300px" },
      ],
      Total: 0,
      curAuth: {},
      show: false,
      authShow: false,
      reamrk: "",
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.getList(1);
  },
  methods: {
    load() {
      if (this.DataList.length == 0) {
        this.getList(1);
      }
    },
    getLabel(list, v) {
      for (let index = 0; index < this[list].length; index++) {
        if (this[list][index].value === v) {
          return this[list][index].name;
        }
      }
    },
    openInfo(row) {
      this.curAuth = row;
      this.show = true;
    },
    openHandler(row) {
      this.reamrk = "";
      this.curAuth = row;
      this.authShow = true;
    },
    updateStatus(status) {
      if (!this.reamrk) {
        this.$message("请输入处理结果");
        return;
      }
      this.$axios({
        url: "/user/mechanismIntention/update",
        method: "post",
        data: {
          id: this.curAuth.id,
          status,
          shop_img: this.reamrk
        },
      }).then((res) => {
        this.authShow = false;
        this.getList(1);
      });
    },
    //列表
    getList(v) {
      let page = v || 1;
      let params = {
        currentPage: page,
        pageSize: 10,
        status: this.query.status,
        type: this.query.type,
        real_name: this.query.principal_mobile,
      };

      this.$axios({
        url: "/user/mechanismIntention/queryManagerListPage",
        params,
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mode-img {
  width: 450px;
  height: 700px;
}
</style>